$(function(){

	var filter_widget = $('.page-product-property-filter'),
		product_list_wrapper_class = 'page-product-list-wrapper',
		header_container_class = 'page-header-container',
		filter_reset_selector = '.page-product-property-filter-btn-reset';
		filter_reset = $(filter_reset_selector),
		product_list_loading_layer_id = 'page-product-list-loading-layer',
		product_filter_active_class = 'page-product-filter-active';

	function showLoadingLayer () {

		var target = $('.' + product_list_wrapper_class),
			layer = target.find('#' + product_list_loading_layer_id);
		if (!layer.length) {
			layer = $('<div id="' + product_list_loading_layer_id + '"></div>').appendTo(target);
		}
		layer
			.css({
				backgroundColor: '#FFFFFF',
				opacity: 0
			})
			.show()
			// .addClass('loading-bg')
			.addClass('loading')
			.position({
				of: target,
				my: 'left top',
				at: 'left top'
			})
			.width(target.width())
			.height(target.height())
			.stop(true, true)
			.delay(500)
			.animate({
				opacity: 0.75
			}, 250);

	}

	function hideLoadingLayer () {

		var target = $('.' + product_list_wrapper_class),
			layer = target.find('#' + product_list_loading_layer_id);
		if (!layer.length) {
			return;
		}
		layer
			.fadeOut(100);

	}

	function updateProductList ( product_property_ids ) {

		if ( typeof( product_property_ids ) === 'undefined' ) {

			product_property_ids = [];

		}

		history.pushState( null, null, '?pf=' + product_property_ids.join('|') );

		showLoadingLayer();

		$.ajax({
				url: '#',
				data: {
					product_property_ids: product_property_ids
				}
	        })
			.done( function (data) {

				hideLoadingLayer();

				if ( data.length ) {

					$('.' + product_list_wrapper_class).empty().append(data);

					/* // scrollt sonst nach jedem Klick runter -> wäre dann so nicht mehr bedienbar -> deaktiviert
					if (ResponsiveBootstrapToolkit.is('<=md')) {
						$.scrollTo($('.' + product_list_wrapper_class), 250, { offset: -$('.' + header_container_class).height() });
					}
					*/

				}

	        })

		;

	}

	filter_widget.find(':checkbox').on('change', function() { // erweitert um radio buttons // und radio buttons dann wieder entfernt, weil sie sich nicht deselektieren lassen

		// console.log('changed');

		// handle fake radio buttons
		var current_checkbox = $(this),
			current_checkbox_dom = current_checkbox.get(0);
		current_checkbox.parent('.page-form-item-type-radio').closest('.page-product-property-filter-group').find(':checkbox').each(function(){
			var checkbox = $(this);
			// console.log(checkbox);
			// if (checkbox !== current_checkbox) { // would not work, b/c jquery objects are never the same
			if (this !== current_checkbox_dom) { // compare DOM elements
				checkbox.prop('checked', false);
				// console.log(checkbox);
			}
		});


		var // cb = $(this),
			product_property_ids = [];

		// collect ids
		filter_widget.find(':checked').each(function(){

			// console.log( $(this).data('id') );
			product_property_ids.push( $(this).data('id') );

		});

		updateProductList( product_property_ids );

		// signalize activated filter to css
		$('.' + product_list_wrapper_class).addClass(product_filter_active_class);

	});

	/* // radiobuttons wieder entfernt
	// allow to deselect radio buttons
	filter_widget.find(':radio').on('click', function () {

		var radio = $(this);
		if ( radio.prop( 'checked' ) === true ) {
			radio.prop( 'checked', false );
		}

	});
	*/


	// reset filter button/links
	// $( document ).on( events, selector, data, handler );
	$(document).on('click', filter_reset_selector, function () {

		// console.log($(this));
		filter_widget.find(':checked').prop('checked', false);
		$('.' + product_list_wrapper_class).removeClass(product_filter_active_class);
		updateProductList();

	});



	// filter ui -- open/close filter groups
	// var filter_widget
	filter_widget.find('.page-product-property-filter-group-label-text').on('click', function () {
		var groupLabel = $(this).parent(),
			group = groupLabel.find('.page-product-property-filter-group'),
			openClass = 'open';
		if (group.is(':visible')) {
			groupLabel.removeClass(openClass);
			group.slideUp();
		} else {
			groupLabel.addClass(openClass);
			group.slideDown();
		}
	});

});